// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1yb_g","list":"BalanceDue_list__3CAxI","listRow":"BalanceDue_listRow__3R46X","total":"BalanceDue_total__Ct4zs"};